import { HttpParams } from "@angular/common/http";
import { QueryParams } from "../../../../frontendlib/src/lib/models";

export class QueryParser 
{

    public static parseQueryParams(): QueryParams
    {
        return {
            payment_id: this.getParamValueQueryString('payment'),
            channel_id: this.getParamValueQueryString('channel') ?? '',
            paymentprovider_id: this.getParamValueQueryString('paymentprovider'),
            error: this.getParamValueQueryString('error'),
            seccode: this.getParamValueQueryString('seccode'),
            token: this.getParamValueQueryString('token'),
            checksuccess: this.getParamValueQueryString('checksuccess'),
            amazonCheckoutSessionId: this.getParamValueQueryString('amazonCheckoutSessionId'),
            showamazon: this.getParamValueQueryString('showamazon')
        }
    }

    public static getAllParams(): HttpParams {
        const url = window.location.href;
        if (url.includes('?')) {
          return new HttpParams({ fromString: url.split('?')[1] });
        }
        return new HttpParams();
      }
    
    public static getAllParamsWithFilter(filter = [] as string[]): { [key: string]: string } {
        const params = QueryParser.getAllParams();
        const keys = params.keys();
        const keyValue: { [key: string]: string } = {};
        for (const key of keys) 
        {
            if (filter.find((val) => val === key) === undefined) 
            {
                keyValue[key] = params.get(key) ?? '';
            }
        }
        return keyValue;
    }
    
    public static getParamValueQueryString(paramName: string): string | undefined {
        const url = window.location.href;
        if (url.includes('?')) 
        {
            const httpParams = new HttpParams({ fromString: url.split('?')[1] });
            const resp = httpParams.get(paramName);
            if (resp === null) 
            {
                return undefined;
            }
            return resp;
        }
        return undefined;
    }

}